export default {
  meta: {
    title: '标签设置'
  }
};
